export const locale = {
    lang: 'en',
    data: {
        'FIELDS': {
            'number': 'Number',
            'text': 'Text',
            'm2200': '0-200 m2',
            'm2201': '201-500 m2',
            'm2500': '> 500 m2',
            'appendix': 'Appendix',
            'm2': 'M2',
            
            'stk10': '0-10 stk.',
            'stk20': '11-20 stk.',
            'stk21': '> 21 stk.',
            'TreatmentType':'Treatment Type',
            'Min': 'Min',
            'indoorOutdoor': 'Interior / Exterior',
            'treatmentType1':{
                'lbM2A': 'M2 A',
                'lbM2B': 'pr. lb. m 15 CM',
                'lbM2C': 'pr. lb. m 30 CM',
                'lbRammerD': 'pr. lb. m 40 CM',
                'lbRuderE': 'pr. lb. m 60 CM',
                'lbFalsF': 'inner rail + step pcs.'
            },
            'treatmentType2':{
                'lbM2A': 'M2 0-200',
                'lbM2B': 'M2 201-500',
                'lbM2C': '500->',
                'lbRammerD': 'pr. lb. m 30 CM',
                'lbRuderE': 'pr. lb. m 60 CM',
                'lbFalsF': 'DKK/Ore M2',
                'lbKantG': 'DKK/Ore 30 CM ',
                'lb15CmH': 'DKK/Ore 60 CM',
                'lb30CmI': 'DKK/Ore 100 CM',
            },
            'treatmentType3':{
                'lbM2A': 'M2 0-200',
                'lbM2B': 'M2 0-200',
                'lbM2C': 'M2 201-500',
                'lbRammerD': 'pr. lb. m 30 CM',
                'lbRuderE': 'pr. lb. m 60 CM',
                'lbFalsF': 'M2 CEILING',
                'lbKantG': 'M2 Walls '
            },
            'treatmentType4':{
                'lbM2A': 'ext. m2 DKK/Ore',
                'lbM2B': 'interior m2 DKK/Ore',
                'lbM2C': 'M2 DKK/Ore',
                'lbRammerD': 'rammer stk. DKK/Ore',
                'lbRuderE': 'windows pc.',
                'lbFalsF': 'false item',
                'lbKantG': 'edge pc.',
                'lb15CmH': 'pr. lb. m. 15cm ',
                'lb30CmI': 'pr. lb. m. 30cm',
                'lb40CmK': 'pr. lb. m. 40cm',
                'lb60CmL': 'pr. lb. m. 60cm',
                'lbIndVangeM': 'in.rail +bumper on ext. Stairs',
            },
            'treatmentType5':{
                'lbM2A': 'M2 200',
                'lbM2B': 'M2 201-500',
                'lbM2C': '501->',
                'lbRammerD': 'M2 0-20',
                'lbRuderE': 'Step surfaces + landings'
            },
            'treatmentType6':{
                'lbM2A': 'Iron, pipes and containers',
                'lbM2C': 'Pipes, flat and angle iron',
                'lbRammerD': 'Rør, fladog vinkeljern',
                'lbKantG': 'Gas meters',
                'lb40CmK': 'Gas meter holders',
                'lb60CmL': 'Air grill',
                'lbIndVangeM': 'Sleeves'
            }
        },
       'BUTTONS':{
            'Add':'Add',
            'BTNSAVE': 'Save',
            'BACK':'Back'
        },
        'MESSAGES': {
            'NORECORD': 'No Record Found',
            'NO_REMINDER_RECORD': 'No Reminder Found',
            'NO_PROJECT_RECORD': 'No Project Found',
            'Created': 'Created successfully.',
            'Updated': 'Updated successfully.',
            'Deleted': 'Deleted successfully.',
            'Failed': 'Something went wrong !',
        },
    }
};